import styles from './PropertiesInfo.module.css';
import Card from '../../../../general/Card';
import Api from '../../../../../services/Api';
import React, { useEffect, useState } from "react";

function PropertiesInfo({distrito}) {
  const [propCadastrada, setPropCadastrada] = useState(null);
  const [produzindo, setPropProduzindo] = useState(null);
  const [naoProduzindo, setPropNProduzindo] = useState(null);

  useEffect(() => {
    // Buscar propriedades cadastradas
    Api.getPropCadastrada(distrito).then((value) => {
      setPropCadastrada(value);
    });

    // Buscar propriedades produzindo
    Api.getPropProduzindo(distrito).then((value) => {
      setPropProduzindo(value);
    });

    // Buscar propriedades não produzindo
    Api.getPropNProduzindo(distrito).then((value) => {
      setPropNProduzindo(value);
    });
  }, [distrito]);

  return (
    <div className={styles.propertiesInfo}>
      <div className={styles.divCards}>
        <Card name="PROP. CADASTRADAS" value={propCadastrada?.value ?? "..."} />
        <Card name="PROP. PRODUZINDO" value={produzindo?.value ?? "..."} />
        <Card name="PROP. NÃO PRODUZINDO" value={naoProduzindo?.value ?? "..."} />
      </div>
    </div>
  );
}

export default PropertiesInfo;
